const initialState = {};

export default (state = initialState, action) => {
    switch (action.type) {
       
        case "VESSEL_REQUIRED_EPIRB_RETRIEVED":
            return action.requiredEpirbRecords;
        default:
            return state;
    }
}
